<template>
	<action-sidebar
	:title="'Editar compañia'"
	:value="true"
	:width="524"
	@close-modal="closeModal">
		<v-layout px-4 mt-3 row wrap>
			<v-flex xs12 mb-4>
				<v-text-field
					background-color="white"
					box
					class="body-1"
					hide-details
					label="Dominio"
					v-model="model.domain"
				></v-text-field>
			</v-flex>
			<v-flex xs12 mb-4>
				<v-text-field
					background-color="white"
					box
					class="body-1"
					hide-details
					label="IdSales"
					v-model="model.salesId"
				></v-text-field>
			</v-flex>
			<v-flex xs12 mb-4>
				<v-select
					background-color="white"
					box
					class="body-1 mt-2"
					hide-details
					item-text="name"
					item-value="id"
					label="Estado"
					:items="status"
					v-model="model.status"
				></v-select>
			</v-flex>
		</v-layout>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				:isLoading="false"
				@accept-button-clicked="saveEdit"
				@cancel-button-clicked="closeModal"
			></modal-sidebar-button>
		</section>
	</action-sidebar>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';

function closeModal() {
	this.goTo('page-config-synchronize-companies');
}

function created() {
	const row = JSON.parse(this.$route.query.data || '{}');
	const { domain, status, id, salesId } = row;
	this.id = id;
	this.model = { domain, status, salesId };
}

function data() {
	return {
		status: [
			{
				id: 1,
				name: 'Registrado',
			},
			{
				id: 2,
				name: 'Pendiente',
			},
			{
				id: 3,
				name: 'Iniciado',
			},
			{
				id: 4,
				name: 'Finalizado',
			},
			{
				id: 5,
				name: 'Error',
			},
		],
		model: {
			status: null,
			domain: null,
			salesId: null,
		},
		id: null,
	};
}

export default {
	name: 'page-config-create',
	components: {
		actionSidebar,
	},
	created,
	data,
	methods: {
		closeModal,
		async saveEdit() {
			const body = this.model;
			try {
				await this.$httpCompany.patch(`ext-companies/${this.id}`, body);
				this.showNotification('Se actualizo correctamente la compañia', 'success');
				this.closeModal();
			} catch (error) {
				this.showNotification('No se pudo actualizar la companía', 'error');
			}
		}
	},
};
</script>




// WEBPACK FOOTER //
// src/pages/configuration/page-config-edit-synchronize.vue